import i18next from 'i18next';

i18next.addResources('es', 'reference', {
  final: 'Inversión final',
  original: 'Inversión original'
});

i18next.addResources('en', 'reference', {
  final: 'Final investment',
  original: 'Original investment'
});

i18next.addResources('pt', 'reference', {
  final: 'Investimento final',
  original: 'Investimento original'
});
